<template>
    <div>
        <VueCtkDateTimePicker
            v-model="value"
            :label="label"
            :format="format"
            :formatted="formatted"
            :onlyDate="onlyDate"
        >
        </VueCtkDateTimePicker>
        <input type="hidden" :id="id" :name="name" v-model="value" v-bind:required="required">
    </div>
</template>

<script>
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

    export default {
        components: {
            VueCtkDateTimePicker,
        },
        props: {
            id: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                required: true,
            },
            value: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                label: 'Select Date',
                format: 'YYYY-MM-DD',
                formatted: 'YYYY-MM-DD',
                onlyDate: true,
            }
        }
    }
</script>
